module.exports = __webpack_public_path__ + "static/media/Address.dacd8bbe.svg";